document.addEventListener('DOMContentLoaded', function() {
  const thumb = document.getElementById('floating-video-widget');
  const overlay = document.getElementById('floating-video-overlay');
  const closeBtn = document.getElementById('floating-video-close');
  const muteBtn = document.getElementById('floating-video-mute');
  const fullVideo = document.getElementById('floating-video-full');
  const addToCartBtn = document.getElementById('floating-video-add-to-cart');

  if (!thumb || !overlay) return;

  thumb.addEventListener('click', function() {
    overlay.classList.add('active');
    fullVideo.play();
  });

  closeBtn.addEventListener('click', function() {
    overlay.classList.remove('active');
    fullVideo.pause();
  });

  muteBtn.addEventListener('click', function() {
    fullVideo.muted = !fullVideo.muted;
    muteBtn.textContent = fullVideo.muted ? '🔇' : '🔊';
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function() {
      const variantId = addToCartBtn.getAttribute('data-variant-id');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(res => res.json())
      .then(() => {
        addToCartBtn.textContent = 'Added!';
        setTimeout(() => { addToCartBtn.textContent = 'Add to Cart'; }, 1500);
      })
      .catch(err => console.error('Add to cart error:', err));
    });
  }
});